import { useMemo } from 'react'

import { Api_AdPlacementType } from '@core/api'
import type { IAppContext } from '@embed/components/helpers'
import type { AnyWidgetAppContext } from '@embed/hooks/useEmbedAppContext'

interface IProps {
  appContext?: AnyWidgetAppContext | IAppContext | null
}

/**
 *
 */
export const useAdsOnly = (props: IProps): boolean => {
  const { appContext } = props

  const isAdsOnly = useMemo(() => {
    if (!appContext || !('adConfig' in appContext)) {
      return false
    }
    return !!appContext.adConfig?.placements?.find(
      (placement) => placement.placement_type === Api_AdPlacementType.OUTSTREAM,
    )
  }, [appContext])

  return isAdsOnly
}
